/*
 * Carnivore Club — free bacon auto-add (v4)
 * Adds: cart-drawer UI refresh after reconcile + DOM lock on bacon line
 * Contract:
 *   - Qualifying sub in cart  => exactly 1 free bacon at qty 1
 *   - No qualifying sub       => zero free bacon
 *   - Customer cannot grow the bacon line beyond qty 1 in the cart drawer UI
 */
(function(){
  'use strict';
  if (window.__CC_BACON_LOADED) return;
  window.__CC_BACON_LOADED = true;

  var BACON_VARIANT_ID = 46021949784148;
  var QUALIFYING_VARIANTS = [46000078815316, 45920671432788];
  var IN_FLIGHT = false;

  // --- CSS to lock bacon line UI ---
  var style = document.createElement('style');
  style.textContent =
    '.cc-bacon-line .quantity-selector,' +
    '.cc-bacon-line cart-quantity-component,' +
    '.cc-bacon-line .quantity-input,' +
    '.cc-bacon-line .quantity,' +
    '.cc-bacon-line button[name="minus"],' +
    '.cc-bacon-line button[name="plus"],' +
    '.cc-bacon-line button[aria-label*="quantity" i],' +
    '.cc-bacon-line button[aria-label*="remove" i],' +
    '.cc-bacon-line button[aria-label*="delete" i],' +
    '.cc-bacon-line .button-remove,' +
    '.cc-bacon-line a[href*="cart/change"],' +
    '.cc-bacon-line [data-line-item-remove],' +
    '.cc-bacon-line button[data-action*="remove" i] {' +
    '  display: none !important;' +
    '  visibility: hidden !important;' +
    '  pointer-events: none !important;' +
    '}' +
    '.cc-bacon-line::after {' +
    '  content: "FREE GIFT — limit 1";' +
    '  display: inline-block;' +
    '  margin-left: 8px;' +
    '  padding: 2px 8px;' +
    '  background: #FBE9E1;' +
    '  color: #A33B22;' +
    '  font-size: 0.7em;' +
    '  font-weight: 700;' +
    '  letter-spacing: 0.04em;' +
    '  text-transform: uppercase;' +
    '  border-radius: 4px;' +
    '  vertical-align: middle;' +
    '}';
  (document.head || document.documentElement).appendChild(style);

  function tagBaconLines() {
    // Find any element referencing the bacon variant ID and add class .cc-bacon-line
    var sels = [
      '[data-variant-id="' + BACON_VARIANT_ID + '"]',
      '[data-variant="' + BACON_VARIANT_ID + '"]',
      '[data-line-item-key*="' + BACON_VARIANT_ID + '"]',
      '[data-cart-item-id*="' + BACON_VARIANT_ID + '"]'
    ];
    sels.forEach(function(s){
      document.querySelectorAll(s).forEach(function(el){
        // Walk up to a likely cart-line ancestor and tag it
        var line = el.closest('cart-items-list-row, cart-line, [class*="cart-item"], [class*="cart-line"], li, tr, [data-line-item-key]');
        (line || el).classList.add('cc-bacon-line');
      });
    });
    // Also tag by product title text as a fallback
    document.querySelectorAll('[class*="cart-item"], [class*="cart-line"], cart-items-list-row, cart-line').forEach(function(el){
      if (/Free Bacon Pack/i.test(el.textContent) && el.textContent.length < 600) {
        el.classList.add('cc-bacon-line');
      }
    });
  }

  // --- Cart reconcile ---
  async function getCart() { return (await fetch('/cart.js', { credentials:'same-origin' })).json(); }
  async function setQty(q) {
    var updates = {}; updates[BACON_VARIANT_ID] = q;
    return fetch('/cart/update.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ updates: updates })
    });
  }
  async function addOne() {
    return fetch('/cart/add.js', {
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: BACON_VARIANT_ID, quantity: 1 }] })
    });
  }
  function broadcastCartUpdated() {
    // Dispatch events that themes commonly listen to so drawer refreshes
    ['cart:updated','cart:refresh','cart:change','cart:item-added','cart:item-removed','cart:drawer:refresh']
      .forEach(function(name){
        document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        document.body && document.body.dispatchEvent(new CustomEvent(name, { bubbles: true }));
      });
    // Try to find cart drawer/cart components and call refresh-like methods
    document.querySelectorAll('cart-drawer, cart-component, cart-items-component, cart-icon-button').forEach(function(el){
      ['refresh','renderContents','update','rerender','onCartUpdate'].forEach(function(m){
        try { if (typeof el[m] === 'function') el[m](); } catch(e){}
      });
    });
  }
  async function reconcile() {
    if (IN_FLIGHT) return;
    IN_FLIGHT = true;
    try {
      var cart = await getCart();
      var baconQty = (cart.items||[]).reduce(function(s,l){
        return ((l.variant_id||l.id) === BACON_VARIANT_ID) ? s + l.quantity : s;
      }, 0);
      var hasSub = (cart.items||[]).some(function(i){
        return QUALIFYING_VARIANTS.indexOf(i.variant_id || i.id) !== -1 && !!i.selling_plan_allocation;
      });
      var changed = false;
      if (hasSub) {
        if (baconQty === 0)      { await addOne();   changed = true; }
        else if (baconQty !== 1) { await setQty(1);  changed = true; }
      } else {
        if (baconQty > 0)        { await setQty(0);  changed = true; }
      }
      if (changed) {
        // Tiny delay so the server commit lands
        setTimeout(function(){ broadcastCartUpdated(); tagBaconLines(); }, 60);
      }
      tagBaconLines();
    } catch(e) { /* ignore */ } finally { IN_FLIGHT = false; }
  }

  // --- Cart endpoint interception ---
  var origFetch = window.fetch;
  window.fetch = function() {
    var args = arguments, url = '';
    if (args[0]) url = (typeof args[0] === 'string') ? args[0] : (args[0].url || '');
    var res = origFetch.apply(this, args);
    if (url && /\/cart\/(add|change|update|clear)\.js/.test(url)) {
      Promise.resolve(res).then(function(){ setTimeout(reconcile, 120); });
    }
    return res;
  };
  var oOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) { this._ccu = url; return oOpen.apply(this, arguments); };
  var oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (this._ccu && /\/cart\/(add|change|update|clear)\.js/.test(this._ccu)) {
      this.addEventListener('loadend', function(){ setTimeout(reconcile, 120); });
    }
    return oSend.apply(this, arguments);
  };

  // --- Theme cart events ---
  ['cart:updated','cart:refresh','cart:item-added','cart:item-removed','cart:change','cart:drawer:open','cart:drawer:refresh'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(function(){ tagBaconLines(); reconcile(); }, 80); });
  });

  // --- MutationObserver to keep tagging bacon lines as drawer re-renders ---
  var mo = new MutationObserver(function(){ tagBaconLines(); });
  function startObserver() {
    if (document.body) mo.observe(document.body, { childList: true, subtree: true });
    else setTimeout(startObserver, 200);
  }

  // --- Initial pass ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      startObserver();
      tagBaconLines();
      setTimeout(reconcile, 600);
    });
  } else {
    startObserver();
    tagBaconLines();
    setTimeout(reconcile, 600);
  }
})();
